import CONSTANTS from "../CONSTANTS";

export const actionGetKitsList = (page = 0, limit = 5, state=null, search=null) => ({
  type: CONSTANTS.KITS_GET_LIST,
  page,
  limit,
  state,
  search
});

export const actionGetKit = (kitId) => ({
  type: CONSTANTS.KITS_GET,
  kitId
});

export const actionUpdateKitInList = (kitId, data) => ({
  type: CONSTANTS.KITS_UPDATE_IN_LIST,
  kitId,
  data
});

export const actionSetKitsList = (kits) => ({
  type: CONSTANTS.KITS_SET_LIST,
  kits,
});

export const actionSetEditKit = (kit) => ({
  type: CONSTANTS.KITS_SET_EDIT,
  kit
});

export const actionKitSubmitEdition = (data) => ({
  type: CONSTANTS.KITS_SUBMIT_EDIT,
  data
})

export const actionKitSubmitForm = (data) => ({
  type: CONSTANTS.KITS_SUBMIT_FORM,
  data
});

export const actionDeleteKit = (kitId) => ({
  type: CONSTANTS.KIT_DELETE,
  kitId
});

export const actionGetKitTypes = () => ({
  type: CONSTANTS.KITS_GET_TYPES,
});

export const actionSetKitTypes = (types) => ({
  type: CONSTANTS.KITS_SET_TYPES,
  types
});

export const actionGetKitStateMachine = () => ({
  type: CONSTANTS.KITS_GET_STATE_MACHINE,
});

export const actionSetKitStateMachine = (machine) => ({
  type: CONSTANTS.KITS_SET_STATE_MACHINE,
  machine
});

// #2121 - Grupos del stepper (5 fases).
export const actionGetKitStateGroups = () => ({
  type: CONSTANTS.KITS_GET_STATE_GROUPS,
});

export const actionSetKitStateGroups = (stateGroups) => ({
  type: CONSTANTS.KITS_SET_STATE_GROUPS,
  stateGroups,
});

export const actionGetKitStateList = () => ({
  type: CONSTANTS.KITS_GET_STATE_LIST,
});

export const actionSetKitStateList = (states) => ({
  type: CONSTANTS.KITS_SET_STATE_LIST,
  states
});

// #2121-spec-kits — practiceId opcional para filtrar el count
export const actionGetKitsCount = (practiceId = null) => ({
  type: CONSTANTS.KITS_GET_COUNT_BY_TYPE,
  practiceId,
});

export const actionSetKitsCount = (count) => ({
  type: CONSTANTS.KITS_SET_COUNT_BY_TYPE,
  count
});

export const actionGetPatientKits = (page = 0, limit = 5, state, search=null) => ({
  type: CONSTANTS.KITS_PATIENTS_GET,
  page,
  limit,
  state,
  search
});

export const actionSetPatientKits = (kits) => ({
  type: CONSTANTS.KITS_PATIENTS_SET,
  kits
});

export const actionUpdateKitStatus = (kitId, status) => ({
  type: CONSTANTS.KIT_PATIENTS_UPDATE_STATUS,
  kitId,
  status
});

// #2121-spec-kits — practiceId opcional para filtrar el count
export const actionGetKitsStateCount = (practiceId = null) => ({
  type: CONSTANTS.KITS_GET_COUNT_BY_STATE,
  practiceId,
});

export const actionSetKitsStateCount = (count) => ({
  type: CONSTANTS.KITS_SET_COUNT_BY_STATE,
  count
});

export const actionSubmitObservations = (kitId, obv) => ({
  type: CONSTANTS.KITS_SAVE_OBSERVATION,
  kitId,
  obv
}); 

export const actionSetKitActiveTab = (tab) => ({
  type: CONSTANTS.KITS_SET_TAB,
  tab
}); 

export const actionClearKit = (kitId, page, limit, activeTab, currentFilter) => ({
  type: CONSTANTS.KITS_CLEAR_KIT,
  kitId,
  page,
  limit,
  activeTab,
  currentFilter
}); 

export const actionSaveKitTracking = (kitId, trackingId) => ({
  type: CONSTANTS.KITS_SAVE_TRACKING_ID,
  kitId,
  trackingId
}); 